// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"639":"15ca155d","847":"ee399b5d"}[chunkId] + ".chunk.js";
};